/**
 * localStorage に保存される useState。
 *
 * 表示モード・タイルサイズ・リストの表示項目など「毎回選び直すのが面倒な設定」に使う。
 * 保存先が壊れていても初期値で動く（設定が戻るだけで、画面は壊さない）。
 *
 * 保存値は JSON なので型の保証は無い。呼び出し側で使う前に必ず検証すること
 * （古いバージョンが書いた値・手で書き換えられた値がそのまま返る）。
 */
import { useEffect, useState } from 'react'

export function usePersistentState<T>(
  key: string,
  initial: T,
): [T, (next: T | ((prev: T) => T)) => void] {
  const [value, setValue] = useState<T>(() => {
    if (typeof window === 'undefined') return initial
    try {
      const raw = window.localStorage.getItem(key)
      if (raw != null) return JSON.parse(raw) as T
    } catch {
      // 壊れた保存値は無視して初期値で開く
    }
    return initial
  })

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // プライベートブラウジング等。設定が保存されないだけ。
    }
  }, [key, value])

  return [value, setValue]
}
